import { useState,useEffect } from "react";
import { useLanguage } from "../Context/LangContext";
import enMenu from "../i18n/English/Home/header.json";
import hiMenu from "../i18n/Hindi/Home/header.json";
import knMenu from "../i18n/Kannada/Home/header.json"
import maMenu from "../i18n/Marathi/Home/header.json";
import guMenu from "../i18n/Gujarati/Home/header.json"
import { AppBar, Toolbar, Box,Grid2, Button, Typography, Slide, SwipeableDrawer, IconButton, Collapse, Divider, Menu, MenuItem,FormControl,Select } from "@mui/material";
import Logo from "../ui-utils/latestPics/navLogo.svg";
import LogoMobile from "../ui-utils/latestPics/navLogo.svg";
import Hamburger  from "../ui-utils/latestPics/Hamburger.svg"
import langLogo from "../Assets/Images_latest/lang_logo.svg"
import btn from "../ui-utils/latestPics/signupbtn1.png"
import btn1 from "../ui-utils/latestPics/signupbtn.png"
import HeaderStyles from "./Header.module.css";
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import useScrollTrigger from "@mui/material/useScrollTrigger";
import { useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate,useLocation } from "react-router-dom";
import CloseIcon from '../ui-utils/latestPics/CloseIcon.svg';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { padding } from "@mui/system";
import Ticker from "../Components/Ticker/Ticker";
import { backendHosts } from "../ui-utils/apiConfig";

// import PropTypes from 'prop-types';
// import CssBaseline from '@mui/material/CssBaseline';

function HideOnScroll(props) {
  const { children, window } = props;

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });




  // const location = useLocation();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children ?? <div />}
    </Slide>
  );
}


const handleClick = () => {

  const baseUrl = `${backendHosts.REG}`

  window.location.href = baseUrl;
};

export default function Header() {
  const isSmallScreen = useMediaQuery("(max-width:1160px)");

  const { language, changeLanguage } = useLanguage();
  const [menuItems, setMenuItems] = useState(enMenu);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLang, setSelectedLang] = useState(language); // store locally

  const [selectedLangLabel, setSelectedLangLabel] = useState("English");
  const [isHovered, setIsHovered] = useState(false);

  const open = Boolean(anchorEl);

  useEffect(() => {
    if (language === "hi") {
      setMenuItems(hiMenu);
    }
     else if (language === "kn") {
      setMenuItems(knMenu);
    }
    else if (language === "ma") {
      setMenuItems(maMenu);
    }
    else if (language === "gu") {
      setMenuItems(guMenu);
    }
     else {
      setMenuItems(enMenu);
    }
  }, [language]);

const languages = [
  { value: "en", label: "English" },
  { value: "hi", label: "हिंदी" },
  { value: "kn", label: "ಕನ್ನಡ" },
  { value: "gu", label: "ગુજરાતી" },
  { value: "ma", label: "मराठी" },
];

  const loginText = {
    en: "Login",
    hi: "लॉगिन",
    kn: "ಲಾಗಿನ್",
    ma: "लॉगिन",
    gu: "લૉગિન"
  };

  const signupText = {
    en: "Sign up",
    hi: "साइनअप",
    kn: "ಸೈನ್ ಅಪ್",
    ma: "साइन अप",
    gu: "સાઇન અપ"
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (lang) => {
    if (lang) {
      changeLanguage(lang);
    }
    setAnchorEl(null);
  };


  const navigate = useNavigate()
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [expanded, setExpanded] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ left: 0, top: 0 });
  const location = useLocation();
  const handleSectionClick = (section) => {
    setExpanded(prev => (prev === section ? null : section));
  };

  const handleExpand = (label) => setExpanded(prev => (prev === label ? null : label));

  // const menuItems = [
  //   {
  //     label: "About Us",
  //     route: "/aboutus",
  //     content: []
  //   },
  //   {
  //     label: "Trade & Invest",
  //     content: [
  //       { name: "Equity", route: "/trade-invest/equity" },
  //       { name: "Derivatives (F&O)", route: "/trade-invest/derivatives" }
  //     ]
  //   },
  //   {
  //     label: "Tools & Calculators",
  //     content: [
  //       { name: "SIP Calculator", route: "/tools-calculators/margin" },
  //       { name: "Brokerage Calculator", route: "/tools-calculators/brokerage" }

  //     ]
  //   },
  //   {
  //     label: "Learn & Research",
  //     content: [
  //       { name: "Blog & Market News", route: "/learn-research/blog-news" },
  //       // { name: "Research Reports", route: "/learn-research/reports" }
  //     ]
  //   },
  //   {
  //     label: "Platforms",
  //     content: [
  //       // { name: "Mobile App", route: "/platforms/mobile-app" },
  //       { name: "APIs for Algo Trading", route: "/platforms/apis" },
  //       // { name: "Web Trading Terminal", route: "/platforms/web-terminal" }
  //     ]
  //   },
  //   {
  //     label: "Partner With Us",
  //     content: [
  //       { name: "Autorized Person", route: "/partner/autorized-person" },
  //       // { name: "Referral Program", route: "/partner/referral" }
  //     ]
  //   },
  //   {
  //     label: "Support",
  //     content: [
  //       { name: "FAQs", route: "/support/faqs" },
  //       { name: "Contact Us", route: "/support/contact" }
  //     ]
  //   }

  // ];

  const handleAbout =()=>{
    navigate("/aboutus")
  }

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };


  return isSmallScreen ? (
    <>
      {/* <CssBaseline /> */}
      <HideOnScroll>
        <AppBar position="fixed" className={HeaderStyles.headerAppbarMob}>
          <Toolbar component="nav"
            aria-label="Main navigation" className={HeaderStyles.headerToolbarMob}>
            {/* Logo Section */}
            <Box
            sx={{ display: "flex", alignItems: "center" }}
            >
              <Box
                // src={LogoMobile}
                className={HeaderStyles.headerLogoAdjustMob}
                onClick={() => {
                  navigate("/");
                  window.scrollTo(0, 0);
                }}
              ></Box>
            </Box>

            {/* Menu Icon Section */}

            <Grid2 sx={{display:"flex",gap:"15px",
              "@media (max-width:425px)": {
                gap: "8px"
              }
            }}>

              <Button
                aria-label="SignupButton"
                onClick={handleClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                sx={{
                  padding: 0,
                  marginTop: "5px",
                  minWidth: 0,
                  borderRadius: "300px", // optional: shape of button (can be 50% for circle)
                  overflow: "hidden",  // ensures image corners match button shape
                  backgroundColor: "transparent", // optional: remove default background
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.1)", // subtle hover effect
                  },
                  "@media (max-width:425px)": {
                    marginTop: "0px",
                  }
                }}
              >
                <Box
                  component="img"
                  src={isHovered ? btn1 : btn}
                  alt="Sign up"
                  sx={{
                    width: "111px",    // adjust as needed
                    height: "35px",   // adjust as needed
                    display: "block",
                    objectFit: "cover",
                    "@media (max-width:600px)": {
                      height: "30px",
                      width: "90px",
                    },

                  }}
                />
              </Button>
              <Box sx={{ display: "flex !important", alignItems: 'end !important', padding: "0px" }}>
                <IconButton onClick={toggleDrawer(true)} sx={{ padding: "0px" }}>
                  <Box
                    component="img"
                    src={Hamburger}
                    alt="Hamburger"
                    sx={{
                      height: "21px",
                      width: "29px",
                      padding: "0px 3px 6px 0px",
                      "@media (max-width:600px)": {
                        height: "18px",
                        width: "25px",
                        paddingBottom: "4px",
                      },
                      "@media (max-width:425px)": {
                        height: "18px",
                        width: "22px",
                      }
                    }}
                  />

                </IconButton>
              </Box>
            </Grid2>

          </Toolbar>
          <Ticker />
        </AppBar>
      </HideOnScroll>

      <SwipeableDrawer
        anchor="top"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        PaperProps={{
          sx: {
            width: '100%',      // Full width
               // Full height (optional if you want fullscreen)
            maxWidth: '100vw',
           // Optional: Background styling
          }
        }}
      >
        {/* Drawer content goes here */}
        <Box >
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#130D15', padding:"5px"   }}>
            <img src={LogoMobile} alt="LOGO" className={HeaderStyles.mobileLogo} onClick={() => {
              navigate("/");
              toggleDrawer(false)
              window.scrollTo(0, 0);
            }} />

            <Grid2>
              {/* <Button
                onClick={handleClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                sx={{
                  padding: 0,
                  marginTop: "5px",
                  minWidth: 0,
                  borderRadius: "300px", // optional: shape of button (can be 50% for circle)
                  overflow: "hidden",  // ensures image corners match button shape
                  backgroundColor: "transparent", // optional: remove default background
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.1)", // subtle hover effect
                  },
                }}
              >
                <img
                  src={isHovered ? btn1 : btn}
                  alt="Sign up"
                  style={{
                    width: "111px",    // adjust as needed
                    height: "35p",   // adjust as needed
                    display: "block",
                    objectFit: "cover",
                  }}
                />
              </Button> */}
              <IconButton aria-label="Open navigation menu"
                aria-expanded={drawerOpen}
                aria-controls="mobile-navigation-drawer"
                onClick={toggleDrawer(false)}>
                <Box
                  component="img"
                  src={CloseIcon}
                  alt="CloseIcon"
                  sx={{ color: "#000000", width: "24px", height: "24px", paddingTop: "5px" }}
                // sx={{
                //   height: "21px",
                //   width: "29px",
                //   padding: "0px 3px 6px 0px",
                //   "@media (max-width:600px)": {
                //     height: "18px",
                //     width: "25  px",
                //     paddingBottom: "4px",

                //   }
                // }}
                />
                {/* <CloseIcon  /> */}
              </IconButton>
            </Grid2>


          </Box>

          {/* Menu Sections */}
          <Box sx={{ backgroundColor: '#130B0B' }}>
            <Box
              onClick={() => {
                navigate("/login");
                setDrawerOpen(false);
                window.scrollTo(0, 0);
              }}
              sx={{
                padding: 2,
                fontFamily: "Inter500",
                fontSize: "14px",
                color: "#ffffff",
                borderBottom: '1px solid #413E4D',
                cursor: "pointer",
                "&:hover": { fontWeight: 600 }
              }}
            >
              {loginText[language] || loginText.en}
            </Box>



            {/* <Box
              onClick={handleClick}
              sx={{
                padding: 2,
                fontFamily: "Inter500",
                fontSize: "14px",
                color: "#ffffff",
                borderBottom: '1px solid #413E4D',
                cursor: "pointer",
                "&:hover": { fontWeight: 600 }
              }}
            >
              {signupText[language] || signupText.en}
            </Box> */}
          </Box>

          {menuItems.map((item, idx) => {
            const isParentActive = item.content.some(sub => location.pathname === sub.route) || location.pathname === item.route;

            return (
              <Box key={idx} sx={{ backgroundColor: '#130B0B'}}>
                {item.content.length > 0 ? (
                  <>
                    <Box
                      onClick={() => handleExpand(item.label)}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 2,
                        cursor: 'pointer',
                        fontFamily: "Inter500",
                        fontSize: "14px",
                        color: "#ffffff",
                        fontWeight: isParentActive ? 600 : 400,
                        borderBottom:  '1px solid #413E4D',
                        "&:hover": {
                          fontWeight: 600
                        }
                      }}
                    >
                      <Typography className={HeaderStyles.submenu}>
                        {item.label}
                      </Typography>
                      {expanded === item.label ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>

                    <Collapse in={expanded === item.label} timeout="auto" unmountOnExit>
                      {item.content.map((subItem, subIdx) => {
                        const isActiveSub = location.pathname === subItem.route;

                        return (
                          <Box
                            key={subIdx}
                            sx={{
                              pl: 5,
                              // fontSize: '14px',
                              lineHeight: "38px",
                              fontFamily: "Inter400",
                              color: '#ffffff',
                              borderTop: subIdx === 0 ? '1px solid #413E4D' : '',
                              borderBottom: subIdx === item.content.length - 1 ? '1px solid #413E4D' : '',
                              cursor: 'pointer',
                              fontWeight: isActiveSub ? 600 : 400,
                              "&:hover": {
                                fontWeight: 600
                              }
                            }}
                            className={HeaderStyles.submenu}
                            onClick={() => {
                              if (subItem.url) {
                                window.open(
                                  subItem.url,
                                  subItem.target || "_blank",
                                  "noopener,noreferrer"
                                );
                              } else if (subItem.route) {
                                navigate(subItem.route);
                                window.scrollTo(0, 0);
                              }
                              setDrawerOpen(false);
                            }}
                          >
                            {subItem.name}
                          </Box>
                        );
                      })}
                    </Collapse>
                  </>
                ) : (
                  <Box
                    onClick={() => {
                      navigate(item.route);
                      setDrawerOpen(false);
                      window.scrollTo(0, 0);
                    }}
                    sx={{
                     padding:2,
                      fontFamily: "Inter500",
                      fontSize: "14px",
                      color: "#ffffff",
                      borderBottom: '1px solid #413E4D',
                      cursor: "pointer",
                      fontFamily: location.pathname === item.route ? "Inter600" : "Inter400",
                      "&:hover": {
                        fontFamily: "Inter600"
                      }
                    }}
                  >
                    {item.label}
                  </Box>
                )}

                <Divider />
              </Box>
            );
          })}


          {/* Language Dropdown Section */}
         {/* Language Selector Section */}
{/* Language Selector Section */}
          <Box sx={{ backgroundColor: '#130B0B', padding: '10px 10px',}}>

            <Box sx={{ border: "1px solid #413E4D", borderRadius: "8px" }}>
  {/* Closed button look */}
  <Box
    onClick={() => setExpanded(expanded === "Language" ? null : "Language")}
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 12px',
      cursor: 'pointer',
      fontFamily: "Inter500",
      fontSize: "16px",
      color: "#ffffff",
      borderRadius: '6px',
      backgroundColor: '#130B0B',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",

    }}
  >
    {selectedLangLabel}
         {expanded === "Language" ? <ExpandLessIcon sx={{ margin: "2px 0px 0px 5px" }} /> : <ExpandMoreIcon sx={{ margin: "2px 0px 0px 5px" }} />}
  </Box>

  {/* Expandable list */}
  <Collapse in={expanded === "Language"} timeout="auto" unmountOnExit>
    {languages.map((lang, idx) => (
      <Box
        key={idx}
        onClick={() => {
          setSelectedLangLabel(lang.label);
          changeLanguage(lang.value);
          setExpanded(null);
          setDrawerOpen(false);
        }}
        sx={{
          padding: '10px 16px',
          cursor: 'pointer',
          fontSize: '16px',
          fontFamily: 'Inter400',
          color: '#ffffff',
          borderBottom: idx === languages.length - 1 ? '1px solid #413E4D' : '',
          backgroundColor: '#130B0B',
          "&:hover": {
            backgroundColor: '#1f1a38',
            fontWeight: 600
          },
          fontWeight: selectedLang === lang.value ? 600 : 400,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {lang.label}
      </Box>
    ))}
  </Collapse>
</Box>

   </Box>



        </Box>

      </SwipeableDrawer>
    </>
  ) : (
    <>
      {/* <CssBaseline /> */}
      <HideOnScroll>
        <AppBar position="fixed" className={HeaderStyles.appBarStyle}>
            <Toolbar component="nav"
              aria-label="Main navigation" className={HeaderStyles.toolBarStyle}>
            {/* Logo and Navigation Links */}
              <Box className={HeaderStyles.toolBoxBarStyle}>
                <img
                  src={Logo}
                  alt="TradeBoss Logo"
                  className={HeaderStyles.logo}
                  onClick={() => {
                    navigate("/");
                    window.scrollTo(0, 0);
                  }}
                />

                <Box
                  sx={{ position: "relative" }}
                  onMouseLeave={() => setHoveredMenu(null)}
                >
                  <Box className={HeaderStyles.menu_box}>
                    {menuItems.map((item, index) => (
                      <Typography
                        key={index}
                        className={HeaderStyles.menuTypo}
                        onMouseEnter={(e) => {
                          if (item.content.length > 0) {
                            const rect = e.currentTarget.getBoundingClientRect();
                            setMenuPosition({ left: rect.left, top: rect.bottom });
                            setHoveredMenu(index);
                          } else {
                            setHoveredMenu(null);
                          }
                        }}
                        onClick={() => {
                          if (item.content.length === 0 && item.route) {
                            navigate(item.route);
                            window.scrollTo(0, 0);
                          }
                        }}
                        sx={{ cursor: "pointer",
                          // marginTop: item.content.length === 0 ? "0px" : "0px"
                          // paddingTop:"10px"
                         }}
                      >
                        <span className={HeaderStyles.menu_label1}>
                          {item.label}
                          {item.content.length > 0 && (
                            <ExpandMoreOutlinedIcon className={HeaderStyles.arrow} />
                          )}
                        </span>
                      </Typography>
                    ))}
                  </Box>


                  {hoveredMenu !== null && menuItems[hoveredMenu].content.length > 0 && (
                    <Box
                      sx={{
                        position: "fixed", // not absolute, since we use `getBoundingClientRect`
                        top: "43px",
                        left: `${menuPosition.left}px`,
                        background: "#fff",
                        padding: "16px",
                        boxShadow: "0px 4px 62px 0px #00000040",
                        borderRadius: "8px",
                        zIndex: 10,
                        width: "170px",
                        display: "flex",
                        flexDirection: "column",
                        pointerEvents: "auto",
                        justifyContent: "center",
                        transform: "translateY(5px)" // optional for nicer hover feel
                      }}
                    >
                      {/* {menuItems[hoveredMenu].content.map((contentItem, idx) => (
                        <Typography
                          key={idx}
                          sx={{
                            color: "#000",
                            marginBottom:
                              idx === menuItems[hoveredMenu].content.length - 1 ? 0 : "8px",
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            navigate(contentItem.route);
                            window.scrollTo(0, 0);
                            setHoveredMenu(null);
                          }}
                        >
                          {contentItem.name}
                        </Typography>
                      ))} */}
                      {menuItems[hoveredMenu].content.map((contentItem, idx) => {
                        const isActive = location.pathname === contentItem.route;
                        return (
                          <Typography
                            key={idx}
                            sx={{
                              color: "#000",
                              marginBottom:
                                idx ===
                                menuItems[hoveredMenu].content.length - 1
                                  ? 0
                                  : "8px",
                              cursor: "pointer",
                              fontFamily: isActive ? "Inter600" : "Inter400",
                              fontWeight: isActive ? "600" : "400",
                              "&:hover": {
                                fontFamily: "Inter600",
                                fontWeight: 600,

                              },
                            }}
                            className={HeaderStyles.menu_list}
                            onClick={() => {
                              if (contentItem.url) {
                                // Open external link (like your PDF)
                                window.open(
                                  contentItem.url,
                                  contentItem.target || "_blank",
                                  "noopener,noreferrer"
                                );
                              } else if (contentItem.route) {
                                // Navigate to internal page
                                navigate(contentItem.route);
                                window.scrollTo(0, 0);
                              }
                              setHoveredMenu(null);
                            }}
                          >
                            {contentItem.name}
                          </Typography>
                        );
                      })}

                    </Box>
                  )}
                </Box>
              </Box>

            {/* Buttons */}
            <Box className={HeaderStyles.menu_LS_buttonStyle}>
                <Button
                  variant="text"
                  className={HeaderStyles.menu_login_buttonStyle}
                  onClick={()=>{
                    navigate("/login")
                  }}
                >
                    {loginText[language] || loginText.en}
                </Button>



                  <Button

                    aria-label="SignupButton"
                    onClick={handleClick}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    sx={{
                      padding: 0,
                      marginTop:"10px",
                      minWidth: 0,
                      borderRadius: "300px", // optional: shape of button (can be 50% for circle)
                      overflow: "hidden",  // ensures image corners match button shape
                      backgroundColor: "transparent", // optional: remove default background
                      "&:hover": {
                        padding: 0,
                      },
                      "@media (max-width:1350px)": {
                        marginTop: "10px",
                      }
                    }}
                  >
                    <img
                      src={isHovered ? btn1 : btn}
                      alt="Sign up"
                      style={{
                        width: "111px",    // adjust as needed
                        height: "35p",   // adjust as needed
                        display: "block",
                        objectFit: "cover",
                        "&:hover": {
                          margin: 0,
                        },
                      }}
                    />
                  </Button>



                {/* <Box
                  component="nav"
                  aria-label="Language navigation"
                > */}
                  <Button
                    id="language-menu-button"
                    variant="outlined"
                    onClick={handleMenuClick}
                    className={HeaderStyles.language_button}
                    aria-label="Select language"
                    aria-haspopup="menu"
                    aria-expanded={open ? "true" : "false"}
                    aria-controls={open ? "language-menu" : undefined}
                    sx={{marginTop:"5px"}}
                  >
                    <img
                      src={langLogo}
                      alt=""
                      aria-hidden="true"
                      className={HeaderStyles.langLogo}
                    />

                    {language === "en"
                      ? "English"
                      : language === "hi"
                        ? "हिंदी"
                        : language === "gu"
                          ? "ગુજરાતી"
                          : language === "ma"
                            ? "मराठी"
                            : "ಕನ್ನಡ"}

                    {open ? (
                      <ExpandLessIcon aria-hidden="true" sx={{ fontSize: 20 }} />
                    ) : (
                      <ExpandMoreIcon aria-hidden="true" sx={{ fontSize: 20 }} />
                    )}
                  </Button>

                  <Menu
                    id="language-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => handleMenuClose()}
                    disablePortal
                    MenuListProps={{
                      "aria-labelledby": "language-menu-button",
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        borderRadius: "12px",
                        backgroundColor: "#fff",
                        boxShadow: "0px 4px 62px 0px #00000040",
                        minWidth: "140px",
                        overflow: "hidden",
                        padding: "0px 8px",
                        "& .MuiMenuItem-root": {
                          fontFamily: "Inter400",
                          fontSize: "calc(14px + var(--font-delta))",
                          color: "#000000",
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                        },
                        "& .MuiMenuItem-root:hover": {
                          background: "#C5E0E766",
                          fontFamily: "Inter700",
                          fontWeight: 700,
                        },
                      },
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    {[
                      { code: "en", label: "English" },
                      { code: "hi", label: "हिंदी" },
                      { code: "kn", label: "ಕನ್ನಡ" },
                      { code: "gu", label: "ગુજરાતી" },
                      { code: "ma", label: "मराठी" },
                    ].map((item) => (
                      <MenuItem
                        key={item.code}
                        selected={language === item.code}
                        onClick={() => handleMenuClose(item.code)}
                        sx={{
                          fontFamily:
                            language === item.code ? "Inter700" : "Inter400",
                          fontWeight: language === item.code ? 700 : 400,
                        }}
                      >
                        {item.label}
                      </MenuItem>
                    ))}
                  </Menu>
                {/* </Box> */}
            </Box>
          </Toolbar>
          <Ticker/>
        </AppBar>
      </HideOnScroll>
    </>
  );
}

// return (
//   <>
//     {/* <CssBaseline /> */}
//     <HideOnScroll >
//       <AppBar
//         position="fixed"
//         sx={{
//           background:
//             "linear-gradient(90.79deg, #260F0E -24.95%, #24183B 33.25%, #EC0606 96.46%)",
//           height: "105px",
//           justifyContent: "center",
//           boxShadow: "none",
//         }}
//       >
//         <Toolbar
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           {/* Logo and Navigation Links */}
//           <Box sx={{ display: "flex", alignItems: "flex-end", gap: "30px" }}>
//             <img
//               src={Logo}
//               alt="TradeBoss Logo"
//               style={{ height: "60px", marginRight: "15px" }}
//             />
//             <Box sx={{ display: "flex", alignItems: "flex-end", gap: "25px" }}>
//               <Typography
//                 sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
//               >
//                 <a href="/aboutus" className={HeaderStyles.menu_label1}>
//                   About Us
//                 </a>
//                 <KeyboardArrowDownIcon />
//               </Typography>
//               <Typography
//                 sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
//               >
//                 <a href="/login" className={HeaderStyles.menu_label1}>
//                   Our Products
//                 </a>
//                 <KeyboardArrowDownIcon />
//               </Typography>
//               <Typography
//                 sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
//               >
//                 <a href="/login" className={HeaderStyles.menu_label1}>
//                   Pricing
//                 </a>
//               </Typography>
//               <Typography
//                 sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
//               >
//                 <a href="/login" className={HeaderStyles.menu_label1}>
//                   Support
//                 </a>
//               </Typography>
//             </Box>
//           </Box>

//           {/* Buttons */}
//           <Box
//             sx={{
//               display: "flex",
//               gap: "15px",
//               position: "relative",
//               top: "15px", // Adjust this value to align with TRADEBOSS
//             }}
//           >
//             <Button
//               variant="text"
//               sx={{
//                 color: "#fff",
//                 textTransform: "none",
//                 fontFamily: "Inter600",
//                 fontSize: "16px !important",
//                 marginRight: "27px !important"
//               }}
//             >
//               Login
//             </Button>
//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "#fff",
//                 color: "#B70B15",
//                 textTransform: "none",
//                 fontFamily: "Inter600",
//                 fontSize: "16px !important",
//                 borderRadius: "21px !important",
//                 padding: "5px 20px",
//               }}
//             >
//               Sign up
//             </Button>
//           </Box>
//         </Toolbar>
//       </AppBar></HideOnScroll></>
// );
